import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpEventType, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss'],
})
export class FileUploadDialogComponent implements OnInit {
    @ViewChild('fileSelector') fileSelector;

    filesToUpload: File[] = [];
    filesProgressValues: number[] = [];
    showCloseButton = false;
    nameOfIdField: string;
    id: number;
    ids: number[];
    apiUrl: string;
    mimeTypeAccepted = 'application/pdf';
    isUploading = false;
    /** Freier Anzeigename (UA-Formulare) */
    showFormularName = false;
    formularBezeichnung = '';

    constructor(
        public dialogRef: MatDialogRef<FileUploadDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private http: HttpClient,
        private messageService: MessageService,
    ) {
        this.nameOfIdField = data.nameOfIdField;
        this.apiUrl = data.apiUrl;
        this.id = data.id;
        this.ids = data.ids;
        this.showFormularName = !!(data.formularName || data.auftragsarten);
    }

    ngOnInit() {
        if (this.data?.allowImages) {
            this.mimeTypeAccepted += ',image/*';
        }
    }

    openFileSelector() {
        this.fileSelector?.nativeElement?.click();
    }

    handleFiles(event: any) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            this.filesToUpload.push(files.item(i));
            this.filesProgressValues[i] = 0;
        }
        if (this.showFormularName && !this.formularBezeichnung.trim() && this.filesToUpload.length) {
            const name = this.filesToUpload[0].name || '';
            this.formularBezeichnung = name.replace(/\.pdf$/i, '').trim();
        }
    }

    uploadFilesToServer() {
        if (this.showFormularName && !this.formularBezeichnung.trim()) {
            this.messageService.infoMessage('Bitte einen Namen für das Formular eingeben.');
            return;
        }
        if (this.filesToUpload.length > 0) {
            this.isUploading = true;
            for (let i = 0; i < this.filesToUpload.length; i++) {
                const fileNumber = i;
                const file = this.filesToUpload[fileNumber];

                const fd = new FormData();
                if (this.ids && this.ids.length > 0) {
                    fd.append(this.nameOfIdField, JSON.stringify(this.ids));
                } else {
                    fd.append(this.nameOfIdField, this.id.toString());
                }
                fd.append('dokument', file);
                if (this.showFormularName) {
                    fd.append('bezeichnung', this.formularBezeichnung.trim());
                }

                const options = {
                    headers: new HttpHeaders('Phito-Type: fileupload'),
                    params: new HttpParams(),
                    reportProgress: true,
                    observe: 'events' as const,
                };

                this.http.post<any>(this.apiBaseUrl + this.apiUrl, fd, options).subscribe({
                    next: event => {
                        if (event.type === HttpEventType.UploadProgress && event.total) {
                            // progress optional
                        } else if (event instanceof HttpResponse) {
                            const body: any = event.body;
                            if (body?.fehler || body?.fehler_recht || body?.errortext) {
                                this.messageService.infoMessage(
                                    'Upload fehlgeschlagen: ' +
                                        (body.fehler || body.fehler_recht || body.errortext),
                                );
                                this.isUploading = false;
                                return;
                            }
                            this.markFileAsUploaded(fileNumber);
                        }
                    },
                    error: err => {
                        console.error('Error while uploading file: ' + file.name);
                        this.messageService.errorMessage('Fehler: Datei konnte nicht hochgeladen werden! ', err);
                        this.isUploading = false;
                    },
                });
            }
        }
    }

    markFileAsUploaded(no: number) {
        this.filesProgressValues[no] = 1;
        this.checkShowCloseButton();
    }

    checkShowCloseButton() {
        let show = true;
        for (let i = 0; i < this.filesProgressValues.length; i++) {
            if (this.filesProgressValues[i] === 0) {
                show = false;
                this.isUploading = true;
            } else {
                this.isUploading = false;
            }
        }
        if (show) {
            this.showCloseButton = true;
        }
    }

    uploadFiles() {
        this.uploadFilesToServer();
    }

    closeDialog() {
        this.dialogRef.close(true);
    }

    onCancelClick(): void {
        this.dialogRef.close(false);
    }
}
